<template>
  <div>
    <!-- <template v-if="!isAdmin"> -->
    <div v-loading="loading" class="info">
      <div>
        <step
          ref="step"
          :flag="flag"
          :steps="steps"
          :step-list="stepList"
          :rule-form="ruleForm"
          :bid-data="bidData"
          :bid-total="bidTotal"
          :bid-query="bidQuery"
          :seat-data="seatData"
          :seat-total="seatTotal"
          :seat-query="seatQuery"
          :monitor-data="monitorData"
          :monitor-total="monitorTotal"
          :monitor-query="monitorQuery"
          @getBidData="getBidData"
          @openUpdate="openUpdate"
          @handleDelete="handleDelete"
          @getSeatData="getSeatData"
          @openSeatUpdate="openSeatUpdate"
          @handleSeatDelete="handleSeatDelete"
          @handleSeatClose="handleSeatClose"
          @getMonitorData="getMonitorData"
          @openMonitorUpdate="openMonitorUpdate"
          @handleMonitorDelete="handleMonitorDelete"
        />
      </div>
    </div>
    <info-detail
      v-if="infoVisible"
      ref="detailInfo"
      @refreshDataList="getBidData"
    />
    <seat-detail
      v-if="seatVisible"
      ref="detailSeat"
      @refreshDataList="getSeatData"
    />
    <monitor-detail
      v-if="monitorVisible"
      ref="detailMonitor"
      @refreshDataList="getMonitorData"
    />
    <!-- </template>
    <template v-else>
      <div class="info">
        <el-table
          :data="listData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="tradeOrgName"
            label="交易中心"
            align="center"
          />
          <el-table-column
            prop="linkMan"
            label="场地联系人"
            align="center"
          />
          <el-table-column
            prop="linkPhone"
            label="联系方式"
            align="center"
          />
          <el-table-column
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openDefend(scope.row)">维护</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            class="limit"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="getData"
          />
        </div>
      </div>
    </template> -->
  </div>
</template>
<script>
import Step from '@/components/Step'
import InfoDetail from './compontents/infoDetail.vue'
import SeatDetail from './compontents/seatDetail.vue'
import MonitorDetail from './compontents/monitorDetail.vue'
export default {
  components: {
    Step,
    InfoDetail,
    SeatDetail,
    MonitorDetail
  },
  props: {
    currentVal: {
      type: Number,
      default: 1
    },
    errorStep: {
      type: Number,
      default: 0
    },
    stepArray: {
      type: Array,
      default: function() {
        return ['步骤1', '步骤2', '步骤3', '步骤4', '步骤5']
      }
    }
  },
  data() {
    return {
      steps: [
        {
          title: '基本信息维护'
        },
        {
          title: '场地信息维护'
        },
        {
          title: '机位信息维护'
        },
        {
          title: '监控信息维护'
        }
      ],
      // isAdmin: true,
      // listData: [],
      // listQuery: {
      //   page: 1,
      //   limit: 10
      // },
      // total: 0,
      loading: false,
      flag: true,
      stepList: [],
      active: 0,
      ruleForm: {
        tradeOrgId: '',
        linkMan: '',
        linkPhone: ''
      },
      bidData: [],
      bidTotal: 0,
      bidQuery: {
        page: 1,
        limit: 7
      },
      infoVisible: false,
      seatData: [],
      seatTotal: 0,
      seatQuery: {
        page: 1,
        limit: 7
      },
      seatVisible: false,
      monitorData: [],
      monitorTotal: 0,
      monitorQuery: {
        page: 1,
        limit: 7
      },
      monitorVisible: false
    }
  },
  computed: {
    orgId: {
      get() { return this.$store.state.user.userinfo.orgInfo.orgId }
    }
  },
  activated() {
    this.bidQuery = this.$options.data.call(this).bidQuery
    this.seatQuery = this.$options.data.call(this).seatQuery
    this.monitorQuery = this.$options.data.call(this).monitorQuery
    // this.getData()
    this.init()
    this.getBidData()
    this.getSeatData()
    this.getMonitorData()
  },
  methods: {
    init() {
      this.loading = true
      const row = JSON.parse(sessionStorage.getItem('row'))
      this.ruleForm.tradeOrgId = row && row.tradeOrgId || this.$store.state.user.userinfo.orgInfo.orgId
      this.$nextTick(() => {
        this.getSteps(this.ruleForm.tradeOrgId)
      })
      if (row && row.tradeOrgId) {
        this.loading = false
        const { linkMan, linkPhone } = row
        this.ruleForm.linkMan = linkMan
        this.ruleForm.linkPhone = linkPhone
      } else {
        this.$http.get(`/evalRoomManages/getEvalRoomInfo?tradeOrgId=${this.ruleForm.tradeOrgId}`).then(res => {
          this.loading = false
          if (res.data.code === '1') {
            const { data } = res.data
            // this.ruleForm.tradeOrgId = data.tradeOrgId
            this.ruleForm.linkMan = data.linkMan
            this.ruleForm.linkPhone = data.linkPhone
            if (data && data.linkMan) {
              this.flag = true
            } else {
              this.flag = false
            }
          }
        })
      }
    },
    // 获取节点
    getSteps(orgId) {
      this.stepList = []
      this.$http.get(`/evalRoomManages/stepsFinished?orgId=${orgId}`).then(res => {
        if (res.data.code === '1') {
          const { data } = res.data
          for (var key in data) {
            const test = key.split('')
            this.stepList.push(test[test.length - 1])
            this.stepList.sort()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取评标室数据
    getBidData() {
      this.$http.post(`/configs/sysevalroom/list`, {
        page: this.bidQuery.page,
        rows: this.bidQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.bidData = data.rows || []
        this.bidTotal = data.total || 0
      })
    },
    // 评标室编辑
    openUpdate(id) {
      this.infoVisible = true
      this.$nextTick(() => {
        this.$refs.detailInfo.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 评标室删除
    handleDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(`/configs/sysevalroom/delete`,{ "id":id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getBidData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
    },
    // 获取机位数据
    getSeatData() {
      this.$http.post(`/configs/sysevalroomseats/list`, {
        page: this.seatQuery.page,
        rows: this.seatQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.seatData = data.rows || []
        this.seatTotal = data.total || 0
      })
    },
    // 机位编辑
    openSeatUpdate(id) {
      this.seatVisible = true
      this.$nextTick(() => {
        this.$refs.detailSeat.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 机位删除
    handleSeatDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(`/configs/sysevalroomseats/delete`, { "id":id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getSeatData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
    },
    // 机位状态
    handleSeatClose(row) {
      const param = { seatStatus: row.seatStatus === 0 ? 1 : 0 }
      const params = Object.assign(row, param)
      this.$http.post(`/evalRoomManages/save`, params).then(res => {
        if (res.data.code === '1') {
          this.$message.success(res.data.msg)
          this.getSeatData()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取监控数据
    getMonitorData() {
      this.$http.post(`/configs/sysevalroomcameras/list`, {
        page: this.monitorQuery.page,
        rows: this.monitorQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.monitorData = data.rows || []
        this.monitorTotal = data.total || 0
      })
    },
    // 监控编辑
    openMonitorUpdate(id) {
      this.monitorVisible = true
      this.$nextTick(() => {
        this.$refs.detailMonitor.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 监控删除
    handleMonitorDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(`/configs/sysevalroomcameras/delete`,{ "id" : id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getMonitorData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.info{
  margin-top:50px;
  // padding:42px 32px
  padding:32px
}
</style>
